import axios from "./axios-handler.service";
const BASE_URL_ENVIOS = "/api/EnviosAutomaticos";

export interface EnvioAutomatico {
  idEnvioAutomatico?: string;
  nome?: string;
  descricao?: string;
  template?: string;
  ativo?: boolean;
  hrExecucao?: string;
}

export interface EnvioAutomaticoParametro {
  idEnvioAutomaticoParametro?: string;
  idEnvioAutomatico?: string;
  numeroParametro?: number;
  tipoParametro?: TipoParametroEnvioAutomatico;
  parametroManual?: string;
  ativo?: boolean;
  regiaoParametro: number;
  indiceBotao?: number;
  subTipoBotao?: string;
}

export interface FiltroEnviosAutomaticos {
  apenasAtivos: boolean;
  txtPesquisa: string;
  offset: number;
  limit: number;
  order?: string;
}

export enum TipoParametro {
  Corpo = 1,
  Botao = 2,
}

export interface TemplateEnvioAutomatico {
  nome: string;
  texto: string;
  parametros: TemplateEnvioAutomaticoParametro[];
  botoes: TemplateEnvioAutomaticoBotao[];
  quantidadeVariaveis: number;
}

export interface TemplateEnvioAutomaticoParametro {
  tipo: TipoParametro;
  indiceBotao?: number;
  exemplo: string;
  subTipoBotao?: string;
}

export interface TemplateEnvioAutomaticoBotao {
  tipo: string;
  texto: string;
}

export enum TipoParametroEnvioAutomatico {
  PrimeiroNome = 1,
  Saudacao = 2,
  Catalogo = 3,
  UltimoPagamento = 4,
  FormaPagamento = 5,
  NomePlano = 6,
  LinkPagamento = 7,
  Manual = 99,
}

export class EnviosAutomaticosService {
  static async listarEnviosAutomaticos(
    filtro: FiltroEnviosAutomaticos
  ): Promise<EnvioAutomatico[]> {
    const { apenasAtivos, txtPesquisa, offset, limit, order } = filtro;
    const response = await axios.get<EnvioAutomatico[]>(
      `${BASE_URL_ENVIOS}/ListarEnviosAutomaticos`,
      {
        params: {
          apenasAtivos,
          txtPesquisa,
          offset,
          limit,
          order,
        },
      }
    );
    return response.data;
  }

  static async obterEnvioAutomatico(
    idEnvioAutomatico: string
  ): Promise<EnvioAutomatico> {
    const response = await axios.get<EnvioAutomatico>(
      `${BASE_URL_ENVIOS}/ObterEnvioAutomatico`,
      {
        params: { idEnvioAutomatico },
      }
    );
    return response.data;
  }

  static async obterParametros(
    idEnvioAutomatico: string
  ): Promise<EnvioAutomaticoParametro[]> {
    const response = await axios.get<EnvioAutomaticoParametro[]>(
      `${BASE_URL_ENVIOS}/ObterParametros`,
      {
        params: { idEnvioAutomatico },
      }
    );
    return response.data || [];
  }

  static async manterEnvioAutomatico(
    envioAutomatico: EnvioAutomatico,
    parametros: EnvioAutomaticoParametro[]
  ): Promise<void> {
    await axios.post(BASE_URL_ENVIOS + "/ManterEnvioAutomatico", {
      envioAutomatico,
      parametros,
    });
  }

  static async ativarEnvioAutomatico(
    envioAutomatico: EnvioAutomatico
  ): Promise<void> {
    await axios.post(
      BASE_URL_ENVIOS + "/AtivarEnvioAutomatico",
      envioAutomatico
    );
  }

  static async obterTemplates(): Promise<TemplateEnvioAutomatico[]> {
    const response = await axios.get<TemplateEnvioAutomatico[]>(
      `${BASE_URL_ENVIOS}/ObterTemplates`
    );
    return response.data;
  }
}
